/** @format */

import Popups from "./Popups";
import noUiSlider from "./../../../node_modules/nouislider/distribute/nouislider.js";

export default class Forms {
	constructor() {
		this.instance = self;
		this.rangeSliderOptions = {
			end: 10000,
			locale: "GBP",
			max: 10000,
			min: 0,
			prefix: "£",
			start: 0,
		};
	}

	static init() {
		const self = new Forms();

		self.attachEvents();

		self.initFileUploads();
		self.initMultiFileUploads();
	}

	static initSelectPlugin($selects) {
		const self = new Forms();
		self.attachSelectPlugin($selects);
	}

	static initRangeSlider($rangeSliders) {
		const self = new Forms();
		self.attachRangeSlider($rangeSliders);
	}

	static setResolutionInputs() {
		$('input[name="_resolution"]').val(window.screen.width + "x" + window.screen.height);
	}

	attachEvents() {
		const self = this;

		self.attachSelectPlugin($(".js-select2"));
		self.attachRangeSlider($(".js-range-slider"));
		self.attachDatePickerPlugin($(".js-datepicker"));

		window.site.attachSelectPlugin = function ($select) {
			self.attachSelectPlugin($select);
		};

		window.site.setResolutionInputs = function () {
			Forms.setResolutionInputs();
		};

		$(document).on("submit", ".js-on-submit-open-popup", function (e) {
			e.preventDefault();
			self.openPopup($(this));
		});

		$(document).on("change", ".js-on-select-clear-dates", function () {
			let $form = $(this).parents("form"),
				$dates = $form.find(".js-datepicker");

			$dates.val("");
		});

		$(document).on("change", ".js-on-change-clear-period", function () {
			let $form = $(this).parents("form"),
				$period = $form.find('select[name="period"]');

			$period.val("");
			self.attachSelectPlugin($period);
		});

		$(document).on("change", ".js-country-select", function (e) {
			e.preventDefault();

			let $wrapper =
					$(this).parents(".checkout-step-group").length > 0
						? $(this).parents(".checkout-step-group")
						: $(this).parents("form"),
				$selectWrapper = $wrapper.find(".js-state-field"),
				$select = $selectWrapper.find("select.js-select2");

			if ($(this).val() == 214) {
				$selectWrapper.removeClass("d-none");
			} else {
				$selectWrapper.addClass("d-none");
			}

			setTimeout(function () {
				self.attachSelectPlugin($select);
			}, 100);
		});

		$(document).on("change", ".js-on-change-filter-statements", function () {
			let $form = $(this).parents("form");
			$form.submit();
		});

		$(document).on("change", ".js-on-change-filter-orders", function () {
			let $form = $(this).parents("form");

			if ($("#order").hasClass("is-active")) {
				oc.request($form[0]);
			} else {
				self.sortVisibleOrderList();
			}
		});

		$(document).on("click", ".js-tab-link", function () {
			let href = $(this).attr("href");

			$("#filterOrderTypes").closest(".form-group").toggleClass("d-none", href !== "#order");

			if (href === "#order" || href === "#kitbuilder-orders" || href === "#back-order") {
				setTimeout(function () {
					$("#filterOrderSort").trigger("change");
				});
			}
		});

		$(document).on("click", ".js-clear-search", function (e) {
			e.preventDefault(); // prevent jump up
			self.clearSearch();
		});
	}

	attachSelectPlugin($selects) {
		const self = this;

		$(function ($) {
			function formatOption(option) {
				if (!option.id) {
					return option.text;
				}

				if (option.element.getAttribute("data-sku")) {
					var $option = $(
						"<span>" +
							option.text +
							'<span class="product-dropdown-reference">SKU: ' +
							option.element.getAttribute("data-sku") +
							"</span></span>"
					);
				} else {
					var $option = $("<span>" + option.text + "</span>");
				}

				return $option;
			}

			$selects.each(function () {
				$(this).select2({
					templateResult: formatOption,
					//templateSelection: formatOption,
					escapeMarkup: function (m) {
						return m;
					},
					placeholder: $(this).attr("placeholder"),
					minimumResultsForSearch: 8,
					dropdownAutoWidth: true,
				});

				const searchPlaceholder = $(this).data("search-placeholder")
					? $(this).data("search-placeholder")
					: "Search...";

				$(this).on("select2:open", function (e) {
					$("input.select2-search__field").prop("placeholder", searchPlaceholder);
				});
			});
		});
	}

	attachRangeSlider($rangeSliders) {
		const self = this;

		if ($rangeSliders.length > 0) {
			$.each($rangeSliders, function (key, slider) {
				let sliderOptions = $(slider).data("range-options") || self.rangeSliderOptions;

				let min = Math.floor(sliderOptions.min || self.rangeSliderOptions.min),
					max = Math.ceil(sliderOptions.max || self.rangeSliderOptions.max),
					start = Math.floor(sliderOptions.start ? sliderOptions.start : min),
					end = Math.ceil(sliderOptions.end ? sliderOptions.end : max);

				noUiSlider.create(slider, {
					start: [start, end],
					connect: true,
					step: 1,
					range: {
						min: min,
						max: max,
					},
				});

				// populate vals on update
				slider.noUiSlider.on("update", function (values, handle) {
					let modLow = $(this.target).parent().find(".form-slider-val.mod-low");

					let modHigh = $(this.target).parent().find(".form-slider-val.mod-high");

					if (sliderOptions.useSuffix == 1 || self.rangeSliderOptions.useSuffix == 1) {
						modLow.text(
							Math.round(values[0]).toLocaleString(sliderOptions.locale) +
								" " +
								(sliderOptions.prefix || self.rangeSliderOptions.prefix)
						);
						modHigh.text(
							Math.round(values[1]).toLocaleString(sliderOptions.locale) +
								" " +
								(sliderOptions.prefix || self.rangeSliderOptions.prefix)
						);
					} else {
						modLow.text(
							(sliderOptions.prefix || self.rangeSliderOptions.prefix) +
								Math.round(values[0]).toLocaleString(sliderOptions.locale)
						);
						modHigh.text(
							(sliderOptions.prefix || self.rangeSliderOptions.prefix) +
								Math.round(values[1]).toLocaleString(sliderOptions.locale)
						);
					}
				});

				// populate inputs and vals on end
				slider.noUiSlider.on("end", function (values, handle) {
					let modLow = $(this.target).parent().find(".form-slider-val.mod-low");

					let modHigh = $(this.target).parent().find(".form-slider-val.mod-high");

					if (sliderOptions.useSuffix == 1 || self.rangeSliderOptions.useSuffix == 1) {
						modLow.text(
							Math.round(values[0]).toLocaleString(sliderOptions.locale) +
								" " +
								(sliderOptions.prefix || self.rangeSliderOptions.prefix)
						);
						modHigh.text(
							Math.round(values[1]).toLocaleString(sliderOptions.locale) +
								" " +
								(sliderOptions.prefix || self.rangeSliderOptions.prefix)
						);
					} else {
						modLow.text(
							(sliderOptions.prefix || self.rangeSliderOptions.prefix) +
								Math.round(values[0]).toLocaleString(sliderOptions.locale)
						);
						modHigh.text(
							(sliderOptions.prefix || self.rangeSliderOptions.prefix) +
								Math.round(values[1]).toLocaleString(sliderOptions.locale)
						);
					}

					$(this.target).parent().find('input[name="minPrice"]').val(values[0]);
					$(this.target).parent().find('input[name="maxPrice"]').val(values[1]);

					$(this.target).parents("form").trigger("fieldChange");
				});
			});
		}
	}

	attachDatePickerPlugin($fields) {
		const self = this;

		$fields.each(function () {
			let $this = $(this),
				maxDate = $this.data("max-date"),
				minDate = $this.data("min-date");

			$this.pickadate({
				min: new Date(minDate),
				max: new Date(maxDate),
				format: "dd/mm/yyyy",
				formatSubmit: "yyyy-mm-dd",
				hiddenName: true,
				container: "body",
				selectMonths: true,
				selectYears: 100,
				today: "",
				clear: "",
				close: "",
			});

			if ($this.data("picker") == "from") {
				let picker = $this.pickadate("picker");

				picker.on("open", function (data) {
					let $form = $this.parents("form"),
						$sibling = $form.find('input[data-picker="to"]'),
						siblingVal = $sibling.val();

					if (siblingVal) {
						let siblingValParts = siblingVal.split("/");
						(siblingValParts = siblingValParts.reverse()),
							(siblingVal = siblingValParts.join("/"));

						picker.set("max", new Date(siblingVal));
					} else {
						picker.set("max", new Date(maxDate));
					}
				});
			}

			if ($this.data("picker") == "to") {
				let picker = $this.pickadate("picker");

				picker.on("open", function (data) {
					let $form = $this.parents("form"),
						$sibling = $form.find('input[data-picker="from"]'),
						siblingVal = $sibling.val();

					if (siblingVal) {
						let siblingValParts = siblingVal.split("/");
						(siblingValParts = siblingValParts.reverse()),
							(siblingVal = siblingValParts.join("/"));

						picker.set("min", new Date(siblingVal));
					} else {
						picker.set("min", new Date(minDate));
					}
				});
			}
		});
	}

	openPopup($form) {
		const self = this;

		let popupUrl = $form.attr("action"),
			$emailInput = $form.find('input[type="email"]'),
			email = $emailInput.val(),
			popups = new Popups();

		$emailInput.val("");
		popups.openAjaxPopup(popupUrl + "?email=" + email);
	}

	clearSearch() {
		const self = this;

		const search = $(".js-search-input");

		search.val("");

		let $form = search.parents("form");

		$form.submit();
	}

	sortVisibleOrderList() {
		const self = this;

		let direction = $("#filterOrderSort").val() === "asc" ? 1 : -1,
			$pane = $(".tabs-pane.is-active");

		$pane.find(".account-orders").each(function () {
			let items = $(this)
				.children(".account-order[data-created]")
				.get()
				.sort(function (a, b) {
					return direction * (a.dataset.created - b.dataset.created);
				});

			$(this).append(items);
		});

		$pane.find(".back-orders-scroll").each(function () {
			let $scroll = $(this),
				pairs = $scroll
					.children(".row[data-created]")
					.map(function () {
						return { row: this, hr: $(this).next("hr")[0] };
					})
					.get()
					.sort(function (a, b) {
						return direction * (a.row.dataset.created - b.row.dataset.created);
					});

			pairs.forEach(function (pair) {
				$scroll.append(pair.row);
				if (pair.hr) {
					$scroll.append(pair.hr);
				}
			});
		});
	}

	initFileUploads() {
		const self = this;
		const $fileUploads = $(".js-file-upload-wrapper");

		if ($fileUploads.length) {
			$fileUploads.each(function () {
				const $wrapper = $(this);
				const $input = $wrapper.find(".file-upload-area-input");
				const $uploadThumbnail = $wrapper.find(".file-upload-area-thumbnail");
				const $uploadLabel = $wrapper.find(".file-upload-area-thumbnail-label");
				const $fileInfo = $wrapper.find(".file-upload-area-info-container");
				const $thumbnail = $fileInfo.find(".file-upload-area-info-thumbnail");
				const $fileName = $fileInfo.find(".file-upload-area-info-details-file-name");
				const $fileSize = $fileInfo.find(".file-upload-area-info-details-file-size");
				const $removeBtn = $fileInfo.find(".file-remove");
				const $errorMsg = $wrapper.find(".file-upload-error-message");

				// Get configuration from data attributes
				const maxSizeMB = parseFloat($wrapper.data("max-size")) || 5;
				const maxSize = maxSizeMB * 1024 * 1024;
				const acceptTypes = $wrapper.data("accept") || "image/*";
				const uploadLabel = $wrapper.data("label") || "Upload your file";

				// Update label text if specified
				if (uploadLabel) {
					$uploadLabel.text(uploadLabel);
				}

				// Handle file selection
				$input.on("change", function () {
					const file = this.files[0];

					// Reset
					$errorMsg.hide();

					if (!file) return;

					// Validate size
					if (file.size > maxSize) {
						showError(`File size exceeds ${maxSizeMB}MB limit`);
						$input.val("");
						return;
					}

					// Validate type
					if (!isFileTypeValid(file, acceptTypes)) {
						showError(`Please upload a file of type: ${acceptTypes}`);
						$input.val("");
						return;
					}

					// Update UI
					$uploadThumbnail.hide();
					$uploadLabel.hide();
					$fileInfo.show();

					$fileName.text(file.name);
					$fileSize.text(formatFileSize(file.size));

					// Create preview if image
					if (file.type.startsWith("image/")) {
						const reader = new FileReader();
						reader.onload = function (e) {
							$thumbnail.html(`<img src="${e.target.result}" alt="Preview">`);
						};
						reader.readAsDataURL(file);
					} else {
						// Show file type icon for non-image files
						$thumbnail.html(
							`<div class="file-type-icon">${getFileTypeIcon(file)}</div>`
						);
					}
				});

				// Handle remove
				$removeBtn.on("click", function () {
					$input.val("");
					$fileInfo.hide();
					$uploadThumbnail.show();
					$uploadLabel.show();
					$thumbnail.empty();
				});

				function showError(message) {
					$errorMsg.text(message).show();
					setTimeout(() => $errorMsg.fadeOut(), 5000);
				}

				function formatFileSize(bytes) {
					if (bytes === 0) return "0 Bytes";
					const k = 1024;
					const sizes = ["Bytes", "KB", "MB", "GB"];
					const i = Math.floor(Math.log(bytes) / Math.log(k));
					return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
				}

				function isFileTypeValid(file, acceptPattern) {
					if (acceptPattern === "*" || acceptPattern === "*/*") return true;

					const patterns = acceptPattern.split(",").map((p) => p.trim());
					return patterns.some((pattern) => {
						if (pattern.endsWith("/*")) {
							const type = pattern.split("/")[0];
							return file.type.startsWith(type + "/");
						}
						return (
							file.type === pattern ||
							pattern === "." + file.name.split(".").pop().toLowerCase()
						);
					});
				}

				function getFileTypeIcon(file) {
					const extension = file.name.split(".").pop().toLowerCase();
					const type = file.type.split("/")[0];

					if (type === "application") {
						if (extension === "pdf") return "PDF";
						if (["doc", "docx"].includes(extension)) return "DOC";
						if (["xls", "xlsx"].includes(extension)) return "XLS";
					}

					return extension.toUpperCase();
				}
			});
		}
	}

	initMultiFileUploads() {
		const self = this;

		const $fileUploads = $(".js-multi-file-upload-wrapper");

		if ($fileUploads.length) {
			$fileUploads.each(function () {
				const $wrapper = $(this);
				const $input = $wrapper.find(".js-multi-file-upload-input");
				const $filesList = $wrapper.find(".file-upload-list");
				const $errorMsg = $wrapper.find(".file-upload-error-message");

				// Track files to maintain remove functionality
				const fileData = new DataTransfer();

				// Get configuration
				const maxSizeMB = parseFloat($wrapper.data("max-size")) || 5;
				const maxSize = maxSizeMB * 1024 * 1024;
				const acceptTypes = $wrapper.data("accept") || "*/*";

				// Handle file selection (preview only)
				$input.on("change", function () {
					const files = Array.from(this.files);
					$errorMsg.hide().empty();

					if (!files.length) return;

					let hasErrors = false;

					files.forEach((file) => {
						// Validate size
						if (file.size > maxSize) {
							showError(`File "${file.name}" exceeds ${maxSizeMB}MB limit`);
							hasErrors = true;
							return;
						}

						// Validate type
						if (!isFileTypeValid(file, acceptTypes)) {
							showError(`File "${file.name}" is not an allowed type`);
							hasErrors = true;
							return;
						}

						// Add to our file list
						fileData.items.add(file);
						// Add preview
						addFilePreview(file);
					});

					console.log(fileData.files);

					// Update the input files
					$input[0].files = fileData.files;

					if (hasErrors) {
						$input.val("");
					}
				});

				function addFilePreview(file) {
					const fileSize = formatFileSize(file.size);

					const $preview = $(`
                    <div class="file-upload-list-item">
                        <div class="file-upload-list-item-info">
                            <div class="file-upload-list-item-icon">
                                ${getFileTypeIcon(file)}
                            </div>
                            <div class="file-upload-list-item-details">
                                <div class="file-upload-list-item-name">${file.name}</div>
                                <div class="file-upload-list-item-size">${fileSize}</div>
                            </div>
                        </div>
                        <button type="button" class="file-remove">
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <path d="M1 1L11 11M11 1L1 11" stroke="#f44336" stroke-width="2"/>
                            </svg>
                        </button>
                    </div>
                `);

					// Add remove handler
					$preview.find(".file-remove").on("click", function () {
						// Remove from DOM
						$preview.remove();

						// Remove from our file list
						const newFiles = Array.from(fileData.files).filter(
							(f) =>
								`${f.name}-${f.size}-${f.lastModified}` !==
								`${file.name}-${file.size}-${file.lastModified}`
						);

						// Update DataTransfer object
						fileData.items.clear();
						newFiles.forEach((f) => fileData.items.add(f));

						console.log(fileData.files);

						// Update input files
						$input[0].files = fileData.files;
					});

					$filesList.append($preview);
				}

				function showError(message) {
					$errorMsg.text(message).show();
					setTimeout(() => $errorMsg.fadeOut(), 5000);
				}

				function formatFileSize(bytes) {
					if (bytes === 0) return "0 Bytes";
					const k = 1024;
					const sizes = ["Bytes", "KB", "MB", "GB"];
					const i = Math.floor(Math.log(bytes) / Math.log(k));
					return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
				}

				function isFileTypeValid(file, acceptPattern) {
					if (acceptPattern === "*" || acceptPattern === "*/*") return true;

					const patterns = acceptPattern.split(",").map((p) => p.trim());
					return patterns.some((pattern) => {
						if (pattern.endsWith("/*")) {
							const type = pattern.split("/")[0];
							return file.type.startsWith(type + "/");
						}
						return (
							file.type === pattern ||
							pattern === "." + file.name.split(".").pop().toLowerCase()
						);
					});
				}

				function getFileTypeIcon(file) {
					const extension = file.name.split(".").pop().toLowerCase();

					if (file.type.startsWith("image/")) {
						return `<img src="${URL.createObjectURL(
							file
						)}" alt="Preview" class="file-upload-item-preview">`;
					}

					if (extension === "pdf") return '<span class="file-type-pdf">PDF</span>';
					if (["doc", "docx"].includes(extension))
						return '<span class="file-type-doc">DOC</span>';
					if (["xls", "xlsx"].includes(extension))
						return '<span class="file-type-xls">XLS</span>';

					return `<span class="file-type-generic">${extension.toUpperCase()}</span>`;
				}
			});
		}
	}
}
